import { render, staticRenderFns } from "./ListContructor.vue?vue&type=template&id=65b13ad4&"
import script from "./ListContructor.vue?vue&type=script&lang=js&"
export * from "./ListContructor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports